import React from "react";
import styled from "styled-components";

const ToggleButton = styled.button`
	z-index: 100000;
	:focus {
		border: 1px solid #007bff;
	}
`;

const TreeViewHeader = ({
	pageName,
	isSidebarVisible,
	setIsSidebarVisible,
	tocHeadingId,
}) => (
	<div className="py-1 m-0 d-flex justify-content-end">
		<div
			className={`justify-content-middle align-items-center mr-0 w-100${
				isSidebarVisible ? " d-flex" : ""
			}`}
		>
			<h2
				id={tocHeadingId}
				className={`text-center p-0 m-0 w-100 text-nowrap ${
					isSidebarVisible ? " show" : " hide"
				}`}
			>
				<div>What’s on This Page</div>
				<div className="page-name">{pageName}</div>
			</h2>
		</div>
		<ToggleButton
			className="btn btn-link py-2 px-0 mx-1"
			aria-label={
				isSidebarVisible
					? "Close table of contents"
					: "Open table of contents"
			}
			onClick={() => {
				setIsSidebarVisible(!isSidebarVisible);
			}}
		>
			<i
				className={`nav-icon ms-Icon${
					isSidebarVisible
						? " ms-Icon--ChevronLeft"
						: " ms-Icon--DoubleBookmark"
				}`}
				aria-hidden="true"
			></i>
		</ToggleButton>
	</div>
);

export default TreeViewHeader;
